import { Role, Visitor, VisitorGroupMembershipInput } from 'graphql/generated/graphqlTypes';

/**
 * Builds the full membership list for `setVisitorById`, changing only the role of the membership in
 * `visitorGroupId`. Every membership keeps its per-group expiration date, otherwise saving would clear it.
 */
export const getMembershipsWithRole = (
  member: Visitor,
  visitorGroupId: string,
  role: Role
): VisitorGroupMembershipInput[] => {
  const buildMemberships = (membership: Visitor['visitorGroupMembership'][number]): VisitorGroupMembershipInput => ({
    visitorGroupId: membership.visitorGroup.id,
    role: membership.visitorGroup.id === visitorGroupId ? role : membership.role,
    expirationDate: membership.expirationDate
  });

  const otherMemberships = member.visitorGroupMembership.filter(
    (membership) => membership.visitorGroup.id !== visitorGroupId
  );
  const groupMembership = member.visitorGroupMembership.find(
    (membership) => membership.visitorGroup.id === visitorGroupId
  );

  return [
    ...otherMemberships.map(buildMemberships),
    groupMembership ? buildMemberships(groupMembership) : { visitorGroupId, role }
  ];
};
